const authInitialState = {
	isLoggedIn: false,
	csrf: null,
	returnUrl: null,
	urlAccessMode: 0,
	user: null,
	authComment: null,
};

export function auth(state = authInitialState, action) {
	switch (action.type) {
		case 'SET_AUTH_ISLOGGEDIN':
			return {
				...state,
				isLoggedIn: true,
				csrf: action.token,
			};
		case 'SET_AUTH_SIGNOUT':
			return {
				...state,
				isLoggedIn: false,
				csrf: null,
				returnUrl: null,
				urlAccessMode: 0,
			};
		case 'SET_LOGIN_RETURNURL':       
			return {
				...state,
				returnUrl: action.payload.path,
				urlAccessMode: action.payload.urlAccessMode,
			};
		case 'SET_USER':
			return {
				...state,
				user: action.value,
			};
		case 'SET_AUTH_COMMENT':
			return {
				...state,
				authComment: action.value,
			};
		default:
			return state;

        // case 'SET_AUTH_CSRFTOKEN':
        // 	return {
        // 		...state,
        // 		credentials: {
        // 			...state.credentials,
        // 			csrf: action.token,
        // 		},
        // 	};

        // case 'SET_AUTH_ISLOGGEDIN':
        //     console.log(action);
        // 	return {
        // 		...state,
        // 		// credentials: {
        // 		// 	...state.credentials,
        // 		// 	isLoggedIn: action.isLoggedIn,
        // 		// },
        // 	};

        // case 'SET_AUTH_ISLOGGINGEND':
        //     return {
        //         ...state,
        //         credentials: {
        //             ...state.credentials,
        //             isLoggingEnd: action.isLoggingEnd,
        //         },
        //     };

        // case 'SET_AUTH_PATH_ISPROTECTED':
        //     return {
        //         ...state,
        //         path: {
        //             ...state.path,
        //             isProtected: action.isProtected,
        //         },
        //     };
        // case 'SET_LOGIN_ISLOADING':
        //     return {
        //         ...state,
        //         login: {
        //             ...state.login,
        //             isLoading: action.value,
        //         },
        //     };
        // case 'SET_LOGIN_ISNOTVALID':
        //     return {
        //         ...state,
        //         login: {
        //             ...state.login,
        //             isNotValid: action.value,
        //         },
        //     };
	}
}
